import {RootState} from 'redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const employeeStatus = createSelector(
  [(state: RootState) => state.employee.isLoading],
  isLoading => isLoading,
);

export const employeeList = createSelector(
  [(state: RootState) => state.employee.employeesList],
  employeesList => employeesList,
);

export const allEmployeesList = createSelector(
  [(state: RootState) => state.employee.allEmployees],
  allEmployees => allEmployees,
);

export const employeeSuccess = createSelector(
  [(state: RootState) => state.employee.successEmployeeState],
  successEmployeeState => successEmployeeState,
);

export const employeeFailure = createSelector(
  [(state: RootState) => state.employee.errorEmployeeState],
  errorEmployeeState => errorEmployeeState,
);

export const employeeTotalPages = createSelector(
  [(state: RootState) => state.employee.totalEmployeePages],
  totalEmployeePages => totalEmployeePages,
);

export const employeeNextPage = createSelector(
  [(state: RootState) => state.employee.nextEmployeePage],
  nextEmployeePage => nextEmployeePage,
);

export const selectedEmployeeID = createSelector(
  [(state: RootState) => state.employee.selectedEmployeeData.id],
  id => id,
);

export const selectedEmployeeData = createSelector(
  [(state: RootState) => state.employee.selectedEmployeeData.data],
  date => date,
);
